module.exports = __webpack_public_path__ + "static/media/17UN-Women8.8e8b2713.jpg";